import React from 'react';

const FloatingShape = ({ className, style, delay = 0 }) => (
  <div
    className={`absolute pointer-events-none ${className}`}
    style={{
      ...style,
      animationDelay: `${delay}s`,
    }}
  />
);

const Background3D = ({ variant = 'layout' }) => {
  if (variant === 'auth') {
    return (
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <FloatingShape
          className="top-[10%] left-[5%] w-20 h-20 rounded-2xl bg-gradient-to-br from-primary-400/30 to-primary-600/20 shadow-3d animate-float blur-[1px]"
          delay={0}
        />
        <FloatingShape
          className="top-[60%] right-[8%] w-16 h-16 rounded-xl bg-gradient-to-br from-secondary-400/30 to-secondary-600/20 shadow-3d animate-float"
          style={{ animationDuration: '8s' }}
          delay={1}
        />
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-primary-500/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-secondary-500/10 rounded-full blur-3xl" />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-primary-50/30 dark:from-black dark:via-neutral-950 dark:to-black transition-colors duration-500" />

      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-radial from-primary-500/5 via-transparent to-transparent -translate-y-1/2 translate-x-1/3" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-radial from-secondary-500/5 via-transparent to-transparent translate-y-1/3 -translate-x-1/4" />

      <FloatingShape
        className="top-[15%] right-[10%] w-24 h-24 rounded-2xl border border-primary-500/10 bg-gradient-to-br from-primary-500/5 to-transparent backdrop-blur-sm animate-float opacity-60 dark:opacity-40"
        style={{ transform: 'rotate(25deg)', animationDuration: '10s' }}
        delay={0}
      />
      <FloatingShape
        className="bottom-[20%] right-[25%] w-16 h-16 rounded-xl border border-secondary-500/10 bg-gradient-to-br from-secondary-500/5 to-transparent animate-float opacity-50 dark:opacity-30"
        style={{ transform: 'rotate(-15deg)', animationDuration: '12s' }}
        delay={1.5}
      />
    </div>
  );
};

export default Background3D;
